// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Container imports
const ArticleProfileCollectionsItem = require('./collections-item')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('ArticleProfileCollections')

class ArticleProfileCollections extends React.PureComponent {
  renderList() {
    const { items } = this.props
    if (!items || !items.length) {
      return null
    }
    return (
      tag('div', {
        className: bem.element('list')
      },
        items.map((item, index) => (
          tag(ArticleProfileCollectionsItem, {
            className: bem.element('list-item'),
            // There is no unique key; falling back to index
            key: `collections-item:${index}`,
            item
          })
        ))
      )
    )
  }

  renderMoreButton() {
    if (!this.props.isMoreAvailable) {
      return null
    }
    return (
      tag('button', {
        className: bem.element('more-button'),
        onClick: this.props.onMoreClick
      },
        'Show more'
      )
    )
  }

  render() {
    return (
      tag('section', {
        className: classNames(
          this.props.className,
          bem.block()
        )
      },
        this.renderList(),
        this.renderMoreButton()
      )
    )
  }
}

ArticleProfileCollections.propTypes = {
  // Flags
  isMoreAvailable: PropTypes.bool,
  // Values
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  // Callbacks
  onMoreClick: PropTypes.func
}

module.exports = ArticleProfileCollections
